module.exports = __webpack_public_path__ + "static/media/Home_background3.004a041f.png";